import React, { useEffect, useState } from 'react';
import { Button, Spinner } from '@material-tailwind/react';
import { FiEdit } from 'react-icons/fi';
import { oneUserPrevisionsApi } from 'api/prevision';
import { productTableApi } from 'api/dashboard';
import { oneUserPrevisionsReportApi } from 'api/prevision';
import { updatePrevisionApi } from 'api/prevision';

// const initialData = [
//   {
//     tcp: 'TCP1',
//     department: 'Dept1',
//     produit: 'Produit1',
//     unite: 'Unit1',
//     q1: '10', q2: '20', q3: '30', q4: '40', total: '100',
//     q5: '15', q6: '25', q7: '35', q8: '45', total2: '120',
//     avPrice: '50',
//     totalSales: '5000',
//     bonus: '200',
//     totalBonus: '220',
//   },
//   {
//     tcp: 'TCP2',
//     department: 'Dept2',
//     produit: 'Produit2',
//     unite: 'Unit2',
//     q1: '11', q2: '21', q3: '31', q4: '41', total: '104',
//     q5: '16', q6: '26', q7: '36', q8: '46', total2: '124',
//     avPrice: '55',
//     totalSales: '5100',
//     bonus: '210',
//     totalBonus: '234',
//   },
// ];

const columns = [
  { key: 'tcp', label: 'TCP' },
  { key: 'department', label: 'Department' },
  { key: 'produit', label: 'Produit' },
  { key: 'packaging', label: 'Emballage' },
  { key: 'unite', label: 'Unité' },
  { key: 'q1', label: 'Q1' },
  { key: 'q2', label: 'Q2' },
  { key: 'q3', label: 'Q3' },
  { key: 'q4', label: 'Q4' },
  { key: 'total', label: 'Total' },
  { key: 'totalSales', label: 'Total sales (TCP)' },
  { key: 'q5', label: 'Q5' },
  { key: 'q6', label: 'Q6' },
  { key: 'q7', label: 'Q7' },
  { key: 'q8', label: 'Q8' },
  { key: 'total2', label: 'Total2' },
  { key: 'totalSales2', label: 'Total sales' },
  { key: 'avPrice', label: 'Av. Price' },
  { key: 'bonus', label: 'Bonus' },
  { key: 'totalBonus', label: 'Total Bonus' },
];

const editableFields = ['q5', 'q6', 'q7', 'q8'];

function PrevisionMainTable({ depotFormAction, closePopup, TcpId, selectedReport, showToast }) {
  const [tableData, setTableData] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [editBuffer, setEditBuffer] = useState({});
  const [productDetails, setProductDetails] = useState([])
  const [reportDetails, setReportDetails] = useState([])
  const [reportId, setReportId] = useState(null)

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getInitialData()
  }, [TcpId])

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const getInitialData = async () => {
    try {
      setIsLoading(true);

      const reportDetailsRes = await oneUserPrevisionsReportApi(selectedReport._id)

      const year = selectedReport?.Created ? selectedReport.Created.split("/")[2] : new Date().getFullYear()

      const productAvrPriceFromYear = new Date(year-1, 0, 1)
      const formatedProductAvrPriceFromYear = formatDate(productAvrPriceFromYear)
      const productAvrPriceToYear = new Date(year-1, 12, 0)
      const formatedProductAvrPriceToYear = formatDate(productAvrPriceToYear)

      const productsDetailsRes = await productTableApi(
        'all',
        'Tout',
        formatedProductAvrPriceFromYear,
        formatedProductAvrPriceToYear
      )
      const tableDataRes = await oneUserPrevisionsApi(TcpId, productsDetailsRes.data)

      setReportId(reportDetailsRes.data._id)
      setReportDetails(reportDetailsRes.data.Rapport)
      setProductDetails(productsDetailsRes.data)
      setTableData(tableDataRes?.data)
    }
    catch (error) {
      console.log(error)
    }
    finally {
      setIsLoading(false);
    }
  }

  const handleEdit = (idx) => {
    setEditingRow(idx);
    setEditBuffer({ ...tableData[idx] });
  };

  const handleInputChange = (e, field) => {
    const value = e.target.value;
    let updated = { ...editBuffer, [field]: value };
    if (['q5', 'q6', 'q7', 'q8'].includes(field)) {
      const sum = ['q5', 'q6', 'q7', 'q8'].reduce((acc, key) => {
        const v = key === field ? value : updated[key];
        return acc + (parseFloat(v) || 0);
      }, 0);
      updated.total2 = sum.toString();
    }
    setEditBuffer(updated);
  };

  const handleSave = (idx) => {
    setTableData(function(prev) {
      const returnValue = prev.map((row, i) => (i === idx ? { ...editBuffer } : row))
      const updatedRow = returnValue[idx]; // get the updated row

            // Update reportDetails with the new Q5, Q6, Q7, Q8 values
      if (updatedRow?.productCode && reportDetails) {
        setReportDetails(function(prevReportDetails) {
          const updatedReportDetails = { ...prevReportDetails };
 
          // Find the category and product in reportDetails
          let productFound = false;
          Object.keys(updatedReportDetails).forEach(category => {
            if (updatedReportDetails[category]?.produits) {
              updatedReportDetails[category].produits = updatedReportDetails[category].produits.map(product => {
                if (product.Code === updatedRow.productCode) {
                  productFound = true;
                  return {
                    ...product,
                    Q5: parseInt(updatedRow.q5) || 0,
                    Q6: parseInt(updatedRow.q6) || 0,
                    Q7: parseInt(updatedRow.q7) || 0,
                    Q8: parseInt(updatedRow.q8) || 0,
                    Total2: parseInt(updatedRow.total2) || 0
                  };
                }
                return product;
              });
            }
          });

          // If product not found in existing categories, create a new category or add to existing one
          if (!productFound) {
            // Try to find the category from the product details
            const productCategory = updatedRow.department || 'Default';
            
            // Initialize category if it doesn't exist
            if (!updatedReportDetails[productCategory]) {
              updatedReportDetails[productCategory] = {
                produits: []
              };
            }
            
            // Initialize produits array if it doesn't exist
            if (!updatedReportDetails[productCategory].produits) {
              updatedReportDetails[productCategory].produits = [];
            }

            // Add the new product to the category
            updatedReportDetails[productCategory].produits.push({
              Code: updatedRow.productCode,
              name: updatedRow.produit,
              Q1: 0, Q2: 0, Q3: 0, Q4: 0, Total: 0,
              Q5: parseInt(updatedRow.q5) || 0,
              Q6: parseInt(updatedRow.q6) || 0,
              Q7: parseInt(updatedRow.q7) || 0,
              Q8: parseInt(updatedRow.q8) || 0,
              Total2: parseInt(updatedRow.total2) || 0,
              categorie: productCategory,
              unity: updatedRow.unite,
              packaging: updatedRow.packaging,
              Bonus: updatedRow.bonus || 0,
              AvPrice: 0,
              TotalSales: 0,
              TotalBonus: 0
            });
          }
          return updatedReportDetails;
        });
      }

      return returnValue
    });
    setEditingRow(null);
    setEditBuffer({});
  };

  const handleCancel = () => {
    setEditingRow(null);
    setEditBuffer({});
  };

  const handleEditeDepot = async () => {
    await updatePrevisionApi(reportId, reportDetails)
    showToast('success', 'Modifiée')
  };
  const handleCancelOp = () => {
    closePopup("Close");
  };

  return (
    <>
      {
        isLoading ?
          <div className="flex items-center justify-center">
            <Spinner className="h-12 w-12" />
          </div>
            :
          <div className="overflow-x-auto" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
            <table className="min-w-[1200px] w-full border text-xs md:text-sm">
              <thead className="sticky top-0 z-10">
                <tr className="bg-gray-100">
                  {columns.map(col => (
                    <th className="p-2 border" key={col.key}>{col.label}</th>
                  ))}
                  <th className="p-2 border">Actions</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, idx) => (
                  <tr key={idx} className={`${row.isSelected ? 'bg-green-100' : 'bg-white'}`}>
                    {columns.map(col => (
                      <td className="border p-1" key={col.key}>
                        {
                          editingRow === idx && editableFields.includes(col.key) ? (
                            <input
                              value={editBuffer[col.key]}
                              onChange={e => handleInputChange(e, col.key)}
                              className="w-12 px-1 border rounded"
                            />
                          ) : editingRow === idx && col.key === 'total2' ? (
                            editBuffer.total2
                          ) : row[col.key]
                        }
                      </td>
                    ))}
                    <td className="border p-1">
                      {editingRow === idx ? (
                        <>
                          <Button
                            size="sm"
                            className="mr-2 rounded-full shadow-md bg-gradient-to-r from-emerald-400 to-green-600 text-white hover:from-emerald-500 hover:to-green-700 transition-colors duration-200"
                            onClick={() => handleSave(idx)}
                          >
                            Enregistrer
                          </Button>
                          <Button
                            size="sm"
                            variant="outlined"
                            className="rounded-full shadow-md border-red-400 text-red-600 hover:bg-red-50 hover:border-red-600 transition-colors duration-200 mt-1"
                            onClick={handleCancel}
                          >
                            Annuler
                          </Button>
                        </>
                      ) : depotFormAction !== "show" ? (
                        <Button
                          size="sm"
                          variant="gradient"
                          color="#236571"
                          onClick={() => handleEdit(idx)}
                          className="rounded-full shadow-md bg-gradient-to-r from-blue-400 to-blue-600 hover:from-blue-500 hover:to-blue-700 p-2 flex items-center justify-center"
                        >
                          <FiEdit className="h-5 w-5 text-white" />
                        </Button>
                      ) : null}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
      }
      {depotFormAction === 'edite' && (
        <div className="mt-5 flex gap-2">
          <Button
            variant="gradient"
            color="#236571"
            onClick={handleEditeDepot}
            className="mr-1"
          >
            <span>Modifier</span>
          </Button>
          <Button
            variant="text"
            color="#cf503f"
            onClick={handleCancelOp}
            className="mr-1"
          >
            <span>Annuler</span>
          </Button>
        </div>
      )}
    </>
  );
}

export default PrevisionMainTable;
